import React from "react";
import EditionSecondRef from "../../Partials/Reports/EditionSecondRef";

const ListReportDisPostOffice2 = () => {
  return (
    <EditionSecondRef
      dpo
      reportDpoOptions
    />
  );
};

export default ListReportDisPostOffice2;
